import { AfterViewInit, Component, computed, ElementRef, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LangService } from '@libs/app.services/lang.service';
import { ResourcesService } from '@libs/app.services/landing/resources.service';
@Component({
  selector: 'app-copyright-footer',

  imports: [CommonModule, TranslateModule],
  templateUrl: './copyright-footer.component.html',
  styleUrl: './copyright-footer.component.scss',
})
export class CopyrightFooterComponent implements AfterViewInit {
  element = viewChild<ElementRef>('element');
  bichoEnabled = computed(() => this.resources.bichoEnabled());
  constructor(
    private langService: LangService,
    private resources: ResourcesService,
  ) {}

  async ngAfterViewInit(): Promise<void> {
    let txt = '';
    if (this.bichoEnabled()) {
      txt = await this.langService.translate('LANDING.copyright');
    } else {
      txt = await this.langService.translate('LANDING.copyright-lbcasino');
    }
    this.element().nativeElement.innerHTML = `<p> ${txt} </p>`;
    this.element().nativeElement.style.display = 'none';
    this.element().nativeElement.style.display = '';
    this.element().nativeElement.querySelector('p').style.cssText = `
      font-size: 1.2rem;
      color: var(--text-color);
      text-align: center;
    `;
    this.element().nativeElement.querySelector('p span').style.cssText = `
      font-weight: bold;
      font-size: 1.2em;
      color: var(--primary-color);
    `;
  }
}
